/* Lumos Clone — Claude · front-end behaviors. Vanilla, no dependencies. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- shared countdown (single interval, all instances) ---------- */
  /* The offer runs on a weekly cycle, so a deadline that has already passed is
     rolled forward in whole weeks — it keeps the same weekday and time and the
     timer never sits at zero. Instances with expiry="hide" opt out and simply
     disappear once their date passes. */
  function rollForward(deadline) {
    var WEEK = 604800000;
    var now = Date.now();
    if (deadline.getTime() > now) return deadline;
    var elapsed = now - deadline.getTime();
    return new Date(deadline.getTime() + (Math.floor(elapsed / WEEK) + 1) * WEEK);
  }

  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-lc-countdown]');
    if (!nodes.length) return;
    var instances = [];
    nodes.forEach(function (node) {
      var deadline = new Date(node.getAttribute('data-deadline') || '');
      if (isNaN(deadline.getTime())) {
        node.hidden = true;
        return;
      }
      var expiry = node.getAttribute('data-expiry') || 'zero';
      if (expiry !== 'hide') deadline = rollForward(deadline);
      instances.push({
        node: node,
        deadline: deadline,
        expiry: expiry,
        cells: {
          days: node.querySelector('[data-lc-count="days"]'),
          hours: node.querySelector('[data-lc-count="hours"]'),
          mins: node.querySelector('[data-lc-count="mins"]'),
          secs: node.querySelector('[data-lc-count="secs"]')
        },
        live: node.querySelector('[data-lc-count-live]'),
        lastLiveMinute: null
      });
    });
    if (!instances.length) return;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = Date.now();
      instances.forEach(function (inst) {
        var diff = inst.deadline.getTime() - now;
        if (diff <= 0) {
          if (inst.expiry === 'hide') {
            inst.node.hidden = true;
            var bar = inst.node.closest('[data-lc-countdown-wrap]');
            if (bar) bar.hidden = true;
            return;
          }
          diff = 0;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        if (inst.cells.days) inst.cells.days.textContent = pad(days);
        if (inst.cells.hours) inst.cells.hours.textContent = pad(hours);
        if (inst.cells.mins) inst.cells.mins.textContent = pad(mins);
        if (inst.cells.secs) inst.cells.secs.textContent = pad(secs);
        if (inst.live && inst.lastLiveMinute !== mins) {
          inst.lastLiveMinute = mins;
          inst.live.textContent = 'Offer ends in ' + days + ' days, ' + hours + ' hours and ' + mins + ' minutes.';
        }
      });
    }
    tick();
    window.setInterval(tick, 1000);
  }

  /* ---------- announcement rotator ---------- */
  function initRotators() {
    document.querySelectorAll('[data-lc-rotator]').forEach(function (root) {
      var msgs = Array.prototype.slice.call(root.querySelectorAll('[data-lc-msg]'));
      if (msgs.length < 2) {
        if (msgs[0]) msgs[0].classList.add('is-active');
        return;
      }
      var idx = 0;
      var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
      var timer = null;

      function show(i) {
        idx = (i + msgs.length) % msgs.length;
        msgs.forEach(function (m, j) {
          m.classList.toggle('is-active', j === idx);
        });
      }
      function next() {
        show(idx + 1);
      }
      function restart() {
        if (timer) window.clearInterval(timer);
        if (!reducedMotion) timer = window.setInterval(next, interval);
      }
      var prevBtn = root.querySelector('[data-lc-rot-prev]');
      var nextBtn = root.querySelector('[data-lc-rot-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { show(idx - 1); restart(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(idx + 1); restart(); });
      show(0);
      restart();
    });
  }

  /* ---------- drawers (menu + cart share mechanics) ---------- */
  var openDrawer = null;

  function trapFocus(container, e) {
    var focusables = container.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function setupDrawer(root) {
    if (!root) return null;
    var lastFocus = null;
    var api = {
      root: root,
      open: function () {
        lastFocus = document.activeElement;
        root.classList.add('is-open');
        root.removeAttribute('aria-hidden');
        document.body.style.overflow = 'hidden';
        openDrawer = api;
        var target = root.querySelector('[data-lc-autofocus]') || root.querySelector('button, a[href]');
        if (target) target.focus();
      },
      close: function () {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (openDrawer === api) openDrawer = null;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    };
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-lc-drawer-close]') || e.target.classList.contains('lc-overlay')) api.close();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' && root.classList.contains('is-open')) trapFocus(root, e);
    });
    return api;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) openDrawer.close();
  });

  function initMenuDrawer() {
    var drawer = setupDrawer(document.querySelector('[data-lc-menu]'));
    if (!drawer) return;
    document.querySelectorAll('[data-lc-burger]').forEach(function (btn) {
      btn.addEventListener('click', drawer.open);
    });
  }

  /* ---------- cart ---------- */
  var cartDrawer = null;

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withComma.split('.')[0]);
  }

  function initCart() {
    var root = document.querySelector('[data-lc-cart]');
    if (!root) return;
    cartDrawer = setupDrawer(root);
    var sectionId = root.getAttribute('data-section-id');
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    document.querySelectorAll('[data-lc-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        cartDrawer.open();
      });
    });

    /* Quantity nudge. Delegated from the document because the same control
       appears inside the drawer and on the cart page, and the drawer's markup
       is replaced on every refresh. The cart page renders its lines on the
       server, so it asks for a reload rather than a drawer that pops open over
       the order the shopper is already reading. */
    document.addEventListener('click', function (e) {
      var up = e.target.closest('[data-lc-upsell]');
      if (!up || up.disabled) return;
      up.disabled = true;
      var reload = up.hasAttribute('data-reload');
      window.lcCart
        .add(up.getAttribute('data-variant'), Number(up.getAttribute('data-add')) || 1)
        .then(function () { if (reload) window.location.reload(); })
        .catch(function () {})
        .finally(function () { if (!reload) up.disabled = false; });
    });

    function broadcast(cart) {
      document.querySelectorAll('[data-lc-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-empty', cart.item_count === 0 ? 'true' : 'false');
      });
      document.dispatchEvent(new CustomEvent('lc:cart:updated', { detail: cart }));
    }

    function renderFromSectionHtml(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-lc-cart-inner]');
      var current = root.querySelector('[data-lc-cart-inner]');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        return true;
      }
      return false;
    }

    function renderFromJson(cart) {
      var lines = root.querySelector('[data-lc-cart-lines]');
      var subtotal = root.querySelector('[data-lc-cart-subtotal]');
      var count = root.querySelector('[data-lc-cart-title-count]');
      var btnTotal = root.querySelector('[data-lc-cart-total]');
      /* The drawer is server-rendered with the checkout button disabled while
         the cart is empty. This fallback path runs when section rendering is
         unavailable, and until now it never cleared that attribute — so the
         first item added on a page that loaded empty left the shopper with a
         dead CHECKOUT button. */
      var checkout = root.querySelector('button[name="checkout"]');
      if (checkout) checkout.disabled = cart.item_count === 0;
      if (count) count.textContent = cart.item_count;
      if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price, moneyFormat);
      if (btnTotal) {
        btnTotal.textContent = cart.item_count
          ? ' · ' + formatMoney(cart.items_subtotal_price, moneyFormat)
          : '';
      }
      if (!lines) return;
      if (!cart.items.length) {
        lines.innerHTML = '<p class="lc-cart__empty">Your cart is empty — your next cozy evening of stitching is one click away.</p>';
        return;
      }
      lines.innerHTML = cart.items.map(function (item) {
        return (
          '<div class="lc-cart-line" data-line-key="' + item.key + '">' +
          '<img class="lc-cart-line__img" src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x160$1$2') : '') + '" alt="" width="76" height="76">' +
          '<div><p class="lc-cart-line__title">' + item.product_title + '</p>' +
          '<p class="lc-cart-line__variant">' + (item.variant_title || '') + '</p>' +
          '<div class="lc-qty">' +
          '<button type="button" class="lc-qty__btn" data-lc-qty-minus data-line-key="' + item.key + '" aria-label="Decrease quantity">−</button>' +
          '<span class="lc-qty__num">' + item.quantity + '</span>' +
          '<button type="button" class="lc-qty__btn" data-lc-qty-plus data-line-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
          '</div></div>' +
          '<div><p class="lc-cart-line__price">' + formatMoney(item.final_line_price, moneyFormat) + '</p>' +
          '<button type="button" class="lc-cart-line__remove" data-lc-remove data-line-key="' + item.key + '">Remove</button></div>' +
          '</div>'
        );
      }).join('');
    }

    function refresh(cart, sectionsHtml) {
      broadcast(cart);
      if (sectionsHtml && sectionId && sectionsHtml[sectionId] && renderFromSectionHtml(sectionsHtml[sectionId])) return;
      renderFromJson(cart);
    }

    function request(url, payload) {
      root.setAttribute('aria-busy', 'true');
      var body = Object.assign({}, payload);
      if (sectionId) body.sections = sectionId;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw e; });
          return res.json();
        })
        .then(function (data) {
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              refresh(cart, data.sections);
              return cart;
            });
        })
        .finally(function () {
          root.removeAttribute('aria-busy');
        });
    }

    /* A failed add is the one error a shopper must never sit through in
       silence — sold out, stale variant, network drop. Surface it where they
       are looking and let the promise stay rejected for callers. */
    function announce(err) {
      var msg =
        (err && (err.description || err.message)) ||
        'Something went wrong adding that. Please try again.';
      var box = document.querySelector('[data-lc-cart-error]');
      if (box) {
        box.textContent = msg;
        box.hidden = false;
        cartDrawer.open();
        window.setTimeout(function () { box.hidden = true; }, 8000);
      } else if (window.console) {
        window.console.warn('[lc-cart]', msg);
      }
    }

    function clearError() {
      var box = document.querySelector('[data-lc-cart-error]');
      if (box) box.hidden = true;
    }

    window.lcCart = {
      add: function (variantId, quantity) {
        clearError();
        return request('/cart/add.js', { id: Number(variantId), quantity: quantity || 1 }).then(function (cart) {
          cartDrawer.open();
          return cart;
        }, function (err) { announce(err); throw err; });
      },
      addItems: function (items) {
        clearError();
        return request('/cart/add.js', { items: items }).then(function (cart) {
          cartDrawer.open();
          return cart;
        }, function (err) { announce(err); throw err; });
      },
      change: function (lineKey, quantity) {
        clearError();
        return request('/cart/change.js', { id: lineKey, quantity: quantity })
          .catch(function (err) { announce(err); throw err; });
      }
    };

    root.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-lc-qty-minus]');
      var plus = e.target.closest('[data-lc-qty-plus]');
      var remove = e.target.closest('[data-lc-remove]');
      if (!minus && !plus && !remove) return;
      var key = (minus || plus || remove).getAttribute('data-line-key');
      var line = root.querySelector('[data-line-key="' + key + '"] .lc-qty__num');
      var qty = line ? parseInt(line.textContent, 10) : 1;
      if (minus) window.lcCart.change(key, Math.max(0, qty - 1));
      if (plus) window.lcCart.change(key, qty + 1);
      if (remove) window.lcCart.change(key, 0);
    });

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(broadcast)
      .catch(function () {});
  }

  /* ---------- product hero: gallery + variants + offer + buy ---------- */
  function initHero() {
    var root = document.querySelector('[data-lc-gallery]');
    if (!root) return;
    var dataEl = document.querySelector('[data-lc-gallery-data]');
    if (!dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var stage = root.querySelector('[data-lc-stage]');
    var thumbTrack = root.querySelector('[data-lc-thumbs]');
    var lightbox = document.querySelector('[data-lc-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('img') : null;
    var state = { slides: [], index: 0, variant: null };

    function slidesForColor(handle) {
      return data.slides.filter(function (s) {
        return !s.colors || !s.colors.length || s.colors.indexOf(handle) !== -1;
      });
    }

    function renderStage() {
      var slide = state.slides[state.index];
      if (!slide) return;
      if (slide.type === 'video') {
        stage.innerHTML =
          '<video data-lc-video muted loop playsinline controls preload="metadata" poster="' + (slide.poster || '') + '">' +
          '<source src="' + slide.mp4 + '" type="video/mp4"></video>';
        var v = stage.querySelector('video');
        if (!reducedMotion) v.play().catch(function () {});
      } else {
        stage.innerHTML =
          '<button type="button" class="lc-gallery__zoom" data-lc-zoom aria-label="Zoom image">' +
          '<img src="' + slide.src + '" alt="' + (slide.alt || '') + '" width="1024" height="1024"></button>';
      }
      Array.prototype.forEach.call(thumbTrack.children, function (t, i) {
        t.classList.toggle('is-active', i === state.index);
        t.setAttribute('aria-current', i === state.index ? 'true' : 'false');
      });
    }

    function renderThumbs() {
      thumbTrack.innerHTML = state.slides.map(function (s, i) {
        var inner = s.type === 'video'
          ? '<img src="' + (s.poster || '') + '" alt="" loading="lazy" width="104" height="104"><span class="lc-thumb__play" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>'
          : '<img src="' + s.thumb + '" alt="" loading="lazy" width="104" height="104">';
        var label = s.type === 'video' ? 'Play product video' : 'View image ' + (i + 1);
        return '<button type="button" class="lc-thumb" data-index="' + i + '" aria-label="' + label + '">' + inner + '</button>';
      }).join('');
    }

    function goTo(i) {
      state.index = (i + state.slides.length) % state.slides.length;
      renderStage();
      var active = thumbTrack.children[state.index];
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    }

    function variantByColor(handle) {
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].handle === handle) return data.variants[i];
      }
      return null;
    }

    function selectVariant(variant, skipUrl) {
      if (!variant) return;
      state.variant = variant;
      state.slides = slidesForColor(variant.handle);
      state.index = 0;
      renderThumbs();
      renderStage();
      document.querySelectorAll('[data-lc-swatch]').forEach(function (sw) {
        sw.classList.toggle('is-active', sw.getAttribute('data-color') === variant.handle);
        sw.setAttribute('aria-pressed', sw.getAttribute('data-color') === variant.handle ? 'true' : 'false');
      });
      var activeCard = document.querySelector('[data-lc-offer-card].is-active');
      if (activeCard) {
        var firstUnit = activeCard.querySelector('[data-lc-unit="0"]');
        if (firstUnit) firstUnit.value = String(variant.id);
      }
      document.querySelectorAll('[data-lc-variant-id]').forEach(function (input) {
        input.value = variant.id;
      });
      document.querySelectorAll('[data-lc-price]').forEach(function (el) {
        el.textContent = variant.price;
      });
      document.querySelectorAll('[data-lc-buy], [data-lc-sticky-atc]').forEach(function (btn) {
        btn.disabled = !variant.available;
        var lbl = btn.getAttribute('data-label') || btn.textContent;
        btn.textContent = variant.available ? lbl : 'Sold out';
      });
      if (!skipUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* wire up */
    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('.lc-thumb');
      if (thumb) goTo(parseInt(thumb.getAttribute('data-index'), 10));
      if (e.target.closest('[data-lc-gal-prev]')) goTo(state.index - 1);
      if (e.target.closest('[data-lc-gal-next]')) goTo(state.index + 1);
      if (e.target.closest('[data-lc-thumb-prev]')) thumbTrack.scrollBy({ left: -240, behavior: 'smooth' });
      if (e.target.closest('[data-lc-thumb-next]')) thumbTrack.scrollBy({ left: 240, behavior: 'smooth' });
      var zoom = e.target.closest('[data-lc-zoom]');
      if (zoom && lightbox && lightboxImg) {
        var slide = state.slides[state.index];
        if (slide && slide.type !== 'video') {
          lightboxImg.src = slide.src;
          lightboxImg.alt = slide.alt || '';
          lightbox.showModal();
        }
      }
    });
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.closest('[data-lc-lightbox-close]')) lightbox.close();
      });
    }

    document.querySelectorAll('[data-lc-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        selectVariant(variantByColor(sw.getAttribute('data-color')));
      });
    });

    /* offer cards: per-unit color selects, radio-style selection */
    function buildUnitRows(card) {
      var rows = card.querySelector('[data-lc-unit-rows]');
      if (!rows || rows.children.length) return;
      var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      var options = data.variants.map(function (v) {
        return '<option value="' + v.id + '">' + v.title + '</option>';
      }).join('');
      var html = '';
      for (var i = 0; i < qty; i++) {
        html +=
          '<span class="lc-offer__unit">' +
          '<span class="lc-offer__unit-num" aria-hidden="true">#' + (i + 1) + '</span>' +
          '<select class="lc-select" data-lc-unit="' + i + '" aria-label="Color for light ' + (i + 1) + '">' + options + '</select>' +
          '</span>';
      }
      rows.innerHTML = html;
      rows.querySelectorAll('[data-lc-unit="0"]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var v = data.variants.filter(function (x) { return String(x.id) === sel.value; })[0];
          if (v) selectVariant(v);
        });
      });
    }

    function activeCard() {
      return document.querySelector('[data-lc-offer-card].is-active');
    }

    function collectItems() {
      var card = activeCard();
      if (!card || !state.variant) return [{ id: Number(state.variant ? state.variant.id : data.variants[0].id), quantity: 1 }];
      var counts = {};
      var selects = card.querySelectorAll('[data-lc-unit]');
      if (!selects.length) {
        counts[state.variant.id] = parseInt(card.getAttribute('data-qty'), 10) || 1;
      } else {
        selects.forEach(function (sel) {
          counts[sel.value] = (counts[sel.value] || 0) + 1;
        });
      }
      return Object.keys(counts).map(function (id) {
        return { id: Number(id), quantity: counts[id] };
      });
    }

    document.querySelectorAll('[data-lc-offer-card]').forEach(function (card) {
      var radio = card.querySelector('input[type="radio"]');
      function activate() {
        document.querySelectorAll('[data-lc-offer-card]').forEach(function (c) {
          c.classList.toggle('is-active', c === card);
        });
        if (radio) radio.checked = true;
        buildUnitRows(card);
        if (state.variant) {
          var firstUnit = card.querySelector('[data-lc-unit="0"]');
          if (firstUnit) firstUnit.value = String(state.variant.id);
        }
      }
      card.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        activate();
      });
      if (radio && radio.checked) activate();
    });

    /* buy buttons — intercept form submit, add via AJAX, open drawer */
    document.querySelectorAll('[data-lc-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.lcCart) return; /* no-JS fallback: native POST /cart/add */
        e.preventDefault();
        var btn = form.querySelector('[data-lc-buy]');
        if (btn) btn.disabled = true;
        window.lcCart.addItems(collectItems())
          .catch(function () {})
          .finally(function () {
            if (btn) btn.disabled = false;
          });
      });
    });
    document.querySelectorAll('[data-lc-sticky-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!window.lcCart || !state.variant || btn.disabled) return;
        btn.disabled = true;
        window.lcCart.addItems(collectItems())
          .catch(function () {})
          .finally(function () { btn.disabled = false; });
      });
    });

    /* initial selection: URL param > first available */
    var params = new URLSearchParams(window.location.search);
    var initial = null;
    if (params.get('variant')) {
      initial = data.variants.filter(function (v) { return String(v.id) === params.get('variant'); })[0];
    }
    selectVariant(initial || data.variants[0], !initial);
  }

  /* ---------- UGC carousel ---------- */
  function initUgc() {
    document.querySelectorAll('[data-lc-ugc]').forEach(function (root) {
      var track = root.querySelector('.lc-ugc__track');
      if (!track) return;
      var prev = root.querySelector('[data-lc-ugc-prev]');
      var next = root.querySelector('[data-lc-ugc-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -180, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: 180, behavior: 'smooth' }); });
      if (reducedMotion) {
        root.querySelectorAll('video').forEach(function (v) {
          v.removeAttribute('autoplay');
          v.pause();
        });
      }
    });
  }

  /* ---------- accordions: only one open ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-lc-acc-group]').forEach(function (group) {
      var items = group.querySelectorAll('details.lc-acc');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (other) {
            if (other !== d) other.open = false;
          });
        });
      });
    });
  }

  /* ---------- modals ---------- */
  function initModals() {
    document.querySelectorAll('[data-lc-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var dlg = document.getElementById(btn.getAttribute('data-lc-modal-open'));
        if (dlg && dlg.showModal) dlg.showModal();
      });
    });
    document.querySelectorAll('dialog.lc-modal').forEach(function (dlg) {
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-lc-modal-close]')) dlg.close();
      });
    });
  }

  /* ---------- newsletter validation ---------- */
  function initNewsletter() {
    document.querySelectorAll('[data-lc-news]').forEach(function (section) {
      var form = section.querySelector('form');
      var input = section.querySelector('input[type="email"]');
      var error = section.querySelector('[data-lc-news-error]');
      if (!form || !input) return;
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (e) {
        var value = input.value.trim();
        var valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
        if (!valid) {
          e.preventDefault();
          input.setAttribute('aria-invalid', 'true');
          if (error) error.textContent = 'Please enter a valid email address — e.g. you@example.com.';
          input.focus();
        } else {
          input.removeAttribute('aria-invalid');
          if (error) error.textContent = '';
        }
      });
    });
  }

  /* ---------- sticky mobile bar ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-lc-stickybar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var watchSel = bar.getAttribute('data-watch') || '[data-lc-buy]';
    var target = document.querySelector(watchSel);
    if (!target) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var below = entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', !entry.isIntersecting && below);
        });
      },
      { threshold: 0 }
    );
    observer.observe(target);
  }

  /* ---------- dynamic date ---------- */
  function initToday() {
    var today = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    document.querySelectorAll('[data-lc-today]').forEach(function (el) {
      el.textContent = today;
    });
  }

  /* ---------- reduced-motion video guard ---------- */
  function initVideoGuard() {
    if (!reducedMotion) return;
    document.querySelectorAll('video[data-lc-video], .lc-ugc__bubble video').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  /* ---------- fixed-position rescue ----------
     The theme editor's zoomed preview puts a CSS transform on a page
     wrapper, which demotes position:fixed to that wrapper's box — the
     sticky bar and drawers then land at the bottom of the page, sized
     to the wrapper instead of the viewport. When a transformed ancestor
     is detected, re-parent the fixed element to <body> (or <html> if
     body itself is transformed) and tag it .lc so it keeps the theme's
     font scope. No-op on the real storefront. */
  function hasTransform(cs) {
    return (
      cs.transform !== 'none' ||
      cs.perspective !== 'none' ||
      (cs.filter && cs.filter !== 'none') ||
      (cs.willChange || '').indexOf('transform') !== -1
    );
  }
  function rescueFixedElements() {
    ['[data-lc-stickybar]', '[data-lc-cart]', '[data-lc-menu]'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var demoted = false;
      for (var n = el.parentElement; n && n !== document.documentElement; n = n.parentElement) {
        if (hasTransform(getComputedStyle(n))) {
          demoted = true;
          break;
        }
      }
      if (!demoted) return;
      var host = hasTransform(getComputedStyle(document.body))
        ? document.documentElement
        : document.body;
      el.classList.add('lc');
      host.appendChild(el);
    });
  }
  function initFixedRescue() {
    rescueFixedElements();
    // The editor applies/changes its zoom transform after load.
    setTimeout(rescueFixedElements, 600);
    setTimeout(rescueFixedElements, 2500);
    var pending;
    window.addEventListener('resize', function () {
      clearTimeout(pending);
      pending = setTimeout(rescueFixedElements, 250);
    });
    document.addEventListener('shopify:section:load', function () {
      setTimeout(rescueFixedElements, 100);
    });
  }

  ready(function () {
    initCountdowns();
    initRotators();
    initMenuDrawer();
    initCart();
    initHero();
    initUgc();
    initAccordions();
    initModals();
    initNewsletter();
    initStickyBar();
    initToday();
    initVideoGuard();
    initFixedRescue();
  });
})();
